/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completePrivacyRequest} from '../api'

export const useMutationCompletePrivacyRequest = createReactQueryMutationHook('completePrivacyRequest', completePrivacyRequest)
